import { generatedApi } from '@shared/api/generated-api';

export const previewEndpoints = {
  generatePreviewPreviewGeneratePost: {
    invalidatesTags: [],
  },
  updatePreviewPreviewUpdatePost: {
    invalidatesTags: [],
  },
  deletePreviewPreviewDeletePost: {
    invalidatesTags: [],
  },
} satisfies Parameters<typeof generatedApi.enhanceEndpoints>[0]['endpoints'];
